export const LS_IS_JUST_SIGNED_IN_VALUE = '1';
export const LS_IS_JUST_SIGNED_IN_NAME = 'justSignedIn';

// Константы для отслеживания новых пользователей после регистрации
export const LS_NEW_USER_SHOW_UPLOAD_VALUE = '1';
export const LS_NEW_USER_SHOW_UPLOAD_NAME = 'newUserShowUpload';